function getComponentDisplayName(component: React.ComponentType) {
  return component.displayName || component.name || 'Component';
}

function wrapComponentDisplayName(
  component: React.ComponentType,
  hocName: string,
) {
  return `${hocName}(${getComponentDisplayName(component)})`;
}

export { getComponentDisplayName, wrapComponentDisplayName };
